import React, { createContext, useContext, useState, useCallback } from 'react';

const I18nContext = createContext(null);

const translations = {
  fr: {
    // Nav
    'nav.home': 'Accueil',
    'nav.about': 'A propos',
    'nav.login': 'Connexion',
    'nav.register': "S'inscrire",
    'nav.dashboard': 'Mon Espace',
    'nav.logout': 'Deconnexion',
    // Auth
    'auth.login_title': 'Connexion',
    'auth.login_desc': 'Accedez a votre espace personnel',
    'auth.register_title': 'Creer un compte',
    'auth.register_desc': 'Inscription gratuite - 0$',
    'auth.google': 'Continuer avec Google',
    'auth.or': 'ou',
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.name': 'Nom complet',
    'auth.country': 'Pays de residence',
    'auth.login_btn': 'Se connecter',
    'auth.register_btn': 'Creer mon compte',
    'auth.no_account': 'Pas encore de compte ?',
    'auth.has_account': 'Deja inscrit ?',
    'auth.connecting': 'Connexion en cours...',
    // Landing page
    'landing.official': 'Plateforme officielle',
    'landing.hero_title': 'Votre identite, ou que vous soyez',
    'landing.hero_subtitle': "Enregistrez-vous et obtenez votre Carte officielle de Congolais de l'Etranger",
    'landing.start_registration': "Commencer l'inscription",
    'landing.free': '100% Gratuit',
    'landing.secure': 'Securise',
    'landing.official_short': 'Officiel',
    'landing.why_card': 'Pourquoi cette carte ?',
    'landing.service_desc': "Un service concu pour simplifier la vie des Congolais a l'etranger",
    'landing.how_it_works': 'Comment ca marche ?',
    'landing.step1': 'Creez votre compte',
    'landing.step1_desc': 'Inscription gratuite en quelques minutes',
    'landing.step2': 'Remplissez votre dossier',
    'landing.step2_desc': 'Informations personnelles et documents',
    'landing.step3': 'Validation ambassade',
    'landing.step3_desc': "Votre dossier est verifie par l'ambassade",
    'landing.step4': 'Recevez votre carte',
    'landing.step4_desc': 'Carte numerique avec QR code securise',
    'landing.about_title': 'A propos du programme',
    'landing.about_text': "La Carte des Congolais de l'Etranger est un document officiel permettant aux citoyens congolais vivant a l'etranger de s'identifier aupres des autorites consulaires. Ce programme gratuit facilite l'acces aux services consulaires et renforce le lien entre la diaspora et la nation.",
    'landing.register_now': "S'inscrire maintenant",
    'landing.news_title': 'Actualites',
    'landing.news_desc': 'Les dernieres nouvelles et informations',
    'landing.cta_title': 'Pret a obtenir votre carte ?',
    'landing.cta_desc': 'Rejoignez des milliers de Congolais de la diaspora deja enregistres.',
    'landing.start_now': 'Commencer maintenant',
    // Citizen nav
    'citizen.dashboard': 'Tableau de Bord',
    'citizen.new_app': 'Nouveau Dossier',
    'citizen.documents': 'Mes Documents',
    'citizen.track': 'Suivi du Statut',
    'citizen.card': 'Ma Carte',
    'citizen.notifications': 'Notifications',
    'citizen.profile': 'Profil',
    // Embassy nav
    'embassy.dashboard': 'Tableau de Bord',
    'embassy.applications': 'Dossiers',
    // Admin nav
    'admin.dashboard': 'Tableau de Bord',
    'admin.embassies': 'Ambassades',
    'admin.users': 'Utilisateurs',
    'admin.cms': 'CMS',
    'admin.audit': "Logs d'Audit",
    // Dashboard
    'dash.welcome': 'Bienvenue,',
    'dash.manage': 'Gerez votre dossier de Carte de Congolais de l\'Etranger',
    'dash.applications': 'Dossiers',
    'dash.cards': 'Cartes',
    'dash.pending': 'En attente',
    'dash.no_app': 'Aucun dossier',
    'dash.no_app_desc': 'Commencez par creer votre premier dossier',
    'dash.create': 'Creer un dossier',
    'dash.my_apps': 'Mes dossiers',
    'dash.new': 'Nouveau',
    // Application
    'app.new_title': 'Nouveau dossier',
    'app.new_desc': 'Remplissez les informations de votre dossier',
    'app.full_name': 'Nom complet',
    'app.dob': 'Date de naissance',
    'app.pob': 'Lieu de naissance',
    'app.gender': 'Genre',
    'app.male': 'Masculin',
    'app.female': 'Feminin',
    'app.nationality': 'Nationalite',
    'app.passport': 'N de Passeport',
    'app.country': 'Pays de residence',
    'app.city': 'Ville de residence',
    'app.address': 'Adresse',
    'app.phone': 'Telephone',
    'app.email': 'Email',
    'app.profession': 'Profession',
    'app.cancel': 'Annuler',
    'app.create_btn': 'Creer le dossier',
    // Documents
    'doc.title': 'Mes Documents',
    'doc.desc': 'Uploadez et gerez vos documents',
    'doc.select': 'Selectionner le dossier',
    'doc.upload_title': 'Uploader un document',
    'doc.upload_desc': 'PDF, JPG ou PNG - Max 10MB',
    'doc.type': 'Type de document',
    'doc.passport': 'Passeport',
    'doc.photo': "Photo d'identite",
    'doc.residence': 'Justificatif de domicile',
    'doc.birth': 'Acte de naissance',
    'doc.other': 'Autre',
    'doc.drop': 'Cliquez ou glissez un fichier',
    'doc.uploaded': 'Documents uploades',
    'doc.submit': 'Soumettre le dossier pour validation',
    // Track
    'track.title': 'Suivi du Statut',
    'track.desc': "Suivez l'avancement de vos dossiers",
    'track.progress': 'Progression',
    'track.country': 'Pays de residence',
    'track.created': 'Cree le',
    'track.submitted': 'Soumis le',
    'track.reviewed': 'Examine le',
    'track.rejection': 'Raison du rejet',
    'track.correction': 'Corrections demandees',
    // Card
    'card.title': 'Ma Carte',
    'card.desc': 'Votre Carte de Congolais de l\'Etranger',
    'card.none': 'Pas encore de carte',
    'card.none_desc': 'Votre carte sera disponible une fois votre dossier approuve.',
    'card.number': 'N de Carte',
    'card.issued': 'Delivree le',
    'card.expires': 'Valide jusqu\'au',
    'card.status': 'Statut',
    'card.active': 'Active',
    'card.inactive': 'Inactive',
    'card.download_png': 'Telecharger PNG',
    'card.download_pdf': 'Telecharger PDF',
    // Verify
    'verify.title': 'Verification de carte',
    'verify.valid': 'Carte valide',
    'verify.invalid': 'Carte introuvable',
    'verify.invalid_desc': 'Le numero de carte saisi ne correspond a aucune carte.',
    'verify.enter': 'Entrez le numero de carte',
    'verify.btn': 'Verifier',
    'verify.name': 'Nom complet',
    'verify.nationality': 'Nationalite',
    'verify.residence': 'Pays de residence',
    'verify.issued': 'Delivree le',
    'verify.expires': 'Valide jusqu\'au',
    'verify.active': 'Carte active',
    // Notifications
    'notif.title': 'Notifications',
    'notif.unread': 'non lue(s)',
    'notif.mark_all': 'Tout marquer lu',
    'notif.none': 'Aucune notification',
    // Profile
    'profile.title': 'Mon Profil',
    'profile.save': 'Sauvegarder',
    // Status
    'status.draft': 'Brouillon',
    'status.submitted': 'Soumis',
    'status.under_review': 'En cours',
    'status.approved': 'Approuve',
    'status.rejected': 'Rejete',
    'status.correction_needed': 'Correction',
    // Embassy portal
    'emb.portal': 'Portail Ambassade',
    'emb.total': 'Total dossiers',
    'emb.pending': 'En attente',
    'emb.approved': 'Approuves',
    'emb.rejected': 'Rejetes',
    'emb.corrections': 'Corrections',
    'emb.search': 'Rechercher par nom...',
    'emb.filter': 'Filtrer',
    'emb.all': 'Tous',
    'emb.no_app': 'Aucun dossier',
    'emb.personal_info': 'Informations personnelles',
    'emb.documents': 'Documents',
    'emb.no_doc': 'Aucun document',
    'emb.approve': 'Approuver',
    'emb.reject': 'Rejeter',
    'emb.correction': 'Correction',
    'emb.notes': 'Notes',
    'emb.confirm': 'Confirmer',
    // Admin
    'admin.title': 'Administration',
    'admin.total_users': 'Utilisateurs',
    'admin.citizens': 'Citoyens',
    'admin.apps': 'Dossiers',
    'admin.total_cards': 'Cartes',
    'admin.total_emb': 'Ambassades',
    'admin.by_country': 'Dossiers par pays',
    'admin.analytics': 'Analytique',
    'analytics.title': 'Tableau de bord analytique',
    'analytics.subtitle': 'Vue d\'ensemble des statistiques et tendances',
    'analytics.app_trend': 'Evolution des dossiers (12 mois)',
    'analytics.user_trend': 'Inscriptions utilisateurs (12 mois)',
    'analytics.by_status': 'Dossiers par statut',
    'analytics.appointments': 'Rendez-vous',
    'analytics.appts_by_embassy': 'Rendez-vous par ambassade',
    'analytics.this_month': 'ce mois',
    'analytics.export_summary': 'Resume',
    'analytics.export_users': 'Utilisateurs',
    'analytics.export_apps': 'Dossiers',
    'analytics.export_appts': 'Rendez-vous',
    'admin.security': 'Securite',
    'security.title': 'Protection brute-force',
    'security.subtitle': 'Gestion des adresses IP et comptes bloques',
    'security.blocked_title': 'Entrees bloquees',
    'security.no_blocked': 'Aucune adresse bloquee. Le systeme est sain.',
    'security.failures': 'echecs',
    'security.blocked_for': 'bloque pour',
    'security.unblock': 'Debloquer',
    'security.unblocked': 'Adresse debloquee avec succes',
    'security.rules_title': 'Regles de blocage progressif',
    'security.rule_5': 'Blocage de 5 minutes apres 5 tentatives echouees',
    'security.rule_10': 'Blocage de 30 minutes apres 10 tentatives echouees',
    'security.rule_20': 'Blocage de 2 heures apres 20+ tentatives echouees',
    'common.refresh': 'Actualiser',
    'common.error': 'Une erreur est survenue',
    'admin.add_embassy': 'Ajouter',
    'admin.edit_embassy': 'Modifier ambassade',
    'admin.new_embassy': 'Nouvelle ambassade',
    'admin.save': 'Sauvegarder',
    'admin.delete': 'Supprimer',
    'admin.role': 'Role',
    'admin.modify': 'Modifier',
    // CMS
    'cms.title': 'Parametres CMS',
    'cms.save': 'Sauvegarder',
    'cms.save_ok': 'Parametres sauvegardes',
    'cms.google_title': 'Google OAuth (SSO)',
    'cms.google_desc': 'Configurez la connexion avec un compte Google',
    'cms.google_howto_title': 'Comment obtenir les identifiants Google :',
    'cms.google_step1': 'Allez sur console.cloud.google.com',
    'cms.google_step2': 'Creez un projet ou selectionnez-en un existant',
    'cms.google_step3': 'APIs & Services > Identifiants > Creer un ID client OAuth 2.0',
    'cms.google_step4': 'Type : Application Web. Ajoutez l\'URI de redirection ci-dessous.',
    'cms.google_redirect_title': 'URI de redirection autorisee :',
    'cms.google_redirect_help': 'Copiez cette URL dans les "URI de redirection autorises" de votre console Google.',
    'cms.identity': 'Identite',
    'cms.identity_desc': 'Titre, description et branding',
    'cms.site_title': 'Titre du site (onglet navigateur)',
    'cms.site_desc': 'Description du site',
    'cms.favicon': 'Favicon',
    'cms.logo': 'Logo',
    'cms.hero': 'Section Hero',
    'cms.hero_title': 'Titre principal',
    'cms.hero_subtitle': 'Sous-titre',
    'cms.hero_image': 'Image hero',
    'cms.about_footer': 'A propos & Footer',
    'cms.about_text': 'Texte A propos',
    'cms.footer_text': 'Texte du footer',
    'cms.contact': 'Contact',
    'cms.contact_email': 'Email de contact',
    'cms.contact_phone': 'Telephone de contact',
    // Pagination
    'pagination.showing': 'Affichage de',
    'pagination.to': 'a',
    'pagination.of': 'sur',
    'pagination.prev': 'Precedent',
    'pagination.next': 'Suivant',
    // Roles
    'role.citizen': 'Citoyen',
    'role.embassy': 'Ambassade',
    'role.admin': 'Administrateur',
    // Common
    'common.loading': 'Chargement...',
    'sections.desc': 'Ajoutez, modifiez et reorganisez les sections de la page d\'accueil',
    'sections.add': 'Ajouter une section',
    'sections.edit': 'Modifier la section',
    'sections.edit_desc': 'Configurez le contenu, l\'image et le bouton de la section',
    'sections.empty': 'Aucune section. Cliquez sur "Ajouter" pour commencer.',
    'sections.title': 'Titre',
    'sections.subtitle': 'Sous-titre',
    'sections.content': 'Contenu',
    'sections.image': 'Image',
    'sections.upload_image': 'Uploader une image',
    'sections.remove_image': 'Supprimer',
    'sections.image_position': 'Position de l\'image',
    'sections.pos_left': 'A gauche du texte',
    'sections.pos_right': 'A droite du texte',
    'sections.button': 'Bouton (optionnel)',
    'sections.button_label': 'Texte du bouton',
    'sections.button_url': 'URL du bouton',
    'sections.url_suggestions': 'Liens internes',
    'sections.cancel': 'Annuler',
    'sections.update': 'Mettre a jour',
    'common.back': 'Retour',
    'common.cancel': 'Annuler',
    'common.choose': 'Choisir',
    'common.date': 'Date',
    'common.action': 'Action',
    'common.by': 'Par',
    'common.no_logs': 'Aucun log',
    'common.country': 'Pays',
    'common.city': 'Ville',
    'common.email': 'Email',
    'common.phone': 'Telephone',
    'common.address': 'Adresse',
    'common.add': 'Ajouter',
    'common.edit': 'Modifier',
    'common.delete': 'Supprimer',
    'common.create': 'Creer',
    'common.confirm_delete': 'Supprimer cet element ?',
    // Appointments
    'appt.title': 'Rendez-vous',
    'appt.desc': 'Prenez rendez-vous dans une ambassade pres de chez vous',
    'appt.my_appointments': 'Mes rendez-vous',
    'appt.select_embassy': 'Choisir l\'ambassade',
    'appt.select_embassy_desc': 'Selectionnez l\'ambassade la plus proche de votre lieu de residence',
    'appt.select_date': 'Choisir la date',
    'appt.select_time': 'Choisir l\'heure',
    'appt.no_slots': 'Aucun creneau disponible ce jour',
    'appt.confirm_title': 'Confirmer le rendez-vous',
    'appt.reason': 'Motif du rendez-vous',
    'appt.confirm': 'Confirmer',
    'appt.confirmed': 'Confirme',
    'appt.cancelled': 'Annule',
    'appt.no_appointments': 'Aucun rendez-vous',
    'appt.citizen': 'Citoyen',
    'appt.time': 'Heure',
    // Schedule
    'schedule.title': 'Horaires d\'ouverture',
    'schedule.desc': 'Definissez les jours et heures d\'ouverture pour les rendez-vous',
    'schedule.opening_hours': 'Creneaux horaires',
    'schedule.opening_desc': 'Configurez les jours, heures, duree et capacite des rendez-vous',
    'schedule.add_day': 'Ajouter un jour',
  },
  en: {
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.login': 'Login',
    'nav.register': 'Sign Up',
    'nav.dashboard': 'My Space',
    'nav.logout': 'Logout',
    'auth.login_title': 'Login',
    'auth.login_desc': 'Access your personal space',
    'auth.register_title': 'Create Account',
    'auth.register_desc': 'Free registration - $0',
    'auth.google': 'Continue with Google',
    'auth.or': 'or',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Full Name',
    'auth.country': 'Country of Residence',
    'auth.login_btn': 'Sign In',
    'auth.register_btn': 'Create Account',
    'auth.no_account': "Don't have an account?",
    'auth.has_account': 'Already registered?',
    'auth.connecting': 'Connecting...',
    // Landing page
    'landing.official': 'Official Platform',
    'landing.hero_title': 'Your identity, wherever you are',
    'landing.hero_subtitle': 'Register and get your official Congolese Diaspora Card',
    'landing.start_registration': 'Start Registration',
    'landing.free': '100% Free',
    'landing.secure': 'Secure',
    'landing.official_short': 'Official',
    'landing.why_card': 'Why this card?',
    'landing.service_desc': 'A service designed to simplify life for Congolese abroad',
    'landing.how_it_works': 'How it works?',
    'landing.step1': 'Create your account',
    'landing.step1_desc': 'Free registration in a few minutes',
    'landing.step2': 'Fill in your application',
    'landing.step2_desc': 'Personal information and documents',
    'landing.step3': 'Embassy validation',
    'landing.step3_desc': 'Your application is verified by the embassy',
    'landing.step4': 'Receive your card',
    'landing.step4_desc': 'Digital card with secure QR code',
    'landing.about_title': 'About the program',
    'landing.about_text': "The Congolese Diaspora Card is an official document allowing Congolese citizens living abroad to identify themselves with consular authorities. This free program facilitates access to consular services and strengthens the link between the diaspora and the nation.",
    'landing.register_now': 'Register Now',
    'landing.news_title': 'News',
    'landing.news_desc': 'Latest news and updates',
    'landing.cta_title': 'Ready to get your card?',
    'landing.cta_desc': 'Join thousands of Congolese diaspora members already registered.',
    'landing.start_now': 'Start Now',
    'citizen.dashboard': 'Dashboard',
    'citizen.new_app': 'New Application',
    'citizen.documents': 'My Documents',
    'citizen.track': 'Track Status',
    'citizen.card': 'My Card',
    'citizen.notifications': 'Notifications',
    'citizen.profile': 'Profile',
    'embassy.dashboard': 'Dashboard',
    'embassy.applications': 'Applications',
    'admin.dashboard': 'Dashboard',
    'admin.embassies': 'Embassies',
    'admin.users': 'Users',
    'admin.cms': 'CMS',
    'admin.audit': 'Audit Logs',
    'dash.welcome': 'Welcome,',
    'dash.manage': 'Manage your Congolese Diaspora Card application',
    'dash.applications': 'Applications',
    'dash.cards': 'Cards',
    'dash.pending': 'Pending',
    'dash.no_app': 'No applications',
    'dash.no_app_desc': 'Start by creating your first application',
    'dash.create': 'Create application',
    'dash.my_apps': 'My applications',
    'dash.new': 'New',
    'app.new_title': 'New Application',
    'app.new_desc': 'Fill in your application details',
    'app.full_name': 'Full Name',
    'app.dob': 'Date of Birth',
    'app.pob': 'Place of Birth',
    'app.gender': 'Gender',
    'app.male': 'Male',
    'app.female': 'Female',
    'app.nationality': 'Nationality',
    'app.passport': 'Passport Number',
    'app.country': 'Country of Residence',
    'app.city': 'City of Residence',
    'app.address': 'Address',
    'app.phone': 'Phone',
    'app.email': 'Email',
    'app.profession': 'Profession',
    'app.cancel': 'Cancel',
    'app.create_btn': 'Create Application',
    'doc.title': 'My Documents',
    'doc.desc': 'Upload and manage your documents',
    'doc.select': 'Select application',
    'doc.upload_title': 'Upload Document',
    'doc.upload_desc': 'PDF, JPG or PNG - Max 10MB',
    'doc.type': 'Document Type',
    'doc.passport': 'Passport',
    'doc.photo': 'ID Photo',
    'doc.residence': 'Proof of Residence',
    'doc.birth': 'Birth Certificate',
    'doc.other': 'Other',
    'doc.drop': 'Click or drag a file',
    'doc.uploaded': 'Uploaded documents',
    'doc.submit': 'Submit application for validation',
    'track.title': 'Track Status',
    'track.desc': 'Track your application progress',
    'track.progress': 'Progress',
    'track.country': 'Country of Residence',
    'track.created': 'Created',
    'track.submitted': 'Submitted',
    'track.reviewed': 'Reviewed',
    'track.rejection': 'Rejection reason',
    'track.correction': 'Requested corrections',
    'card.title': 'My Card',
    'card.desc': 'Your Congolese Diaspora Card',
    'card.none': 'No card yet',
    'card.none_desc': 'Your card will be available once your application is approved.',
    'card.number': 'Card Number',
    'card.issued': 'Issued on',
    'card.expires': 'Valid until',
    'card.status': 'Status',
    'card.active': 'Active',
    'card.inactive': 'Inactive',
    'card.download_png': 'Download PNG',
    'card.download_pdf': 'Download PDF',
    'verify.title': 'Card Verification',
    'verify.valid': 'Valid card',
    'verify.invalid': 'Card not found',
    'verify.invalid_desc': 'The card number entered does not match any card.',
    'verify.enter': 'Enter card number',
    'verify.btn': 'Verify',
    'verify.name': 'Full Name',
    'verify.nationality': 'Nationality',
    'verify.residence': 'Country of Residence',
    'verify.issued': 'Issued on',
    'verify.expires': 'Valid until',
    'verify.active': 'Active card',
    'notif.title': 'Notifications',
    'notif.unread': 'unread',
    'notif.mark_all': 'Mark all as read',
    'notif.none': 'No notifications',
    'profile.title': 'My Profile',
    'profile.save': 'Save',
    'status.draft': 'Draft',
    'status.submitted': 'Submitted',
    'status.under_review': 'Under Review',
    'status.approved': 'Approved',
    'status.rejected': 'Rejected',
    'status.correction_needed': 'Correction',
    'emb.portal': 'Embassy Portal',
    'emb.total': 'Total applications',
    'emb.pending': 'Pending',
    'emb.approved': 'Approved',
    'emb.rejected': 'Rejected',
    'emb.corrections': 'Corrections',
    'emb.search': 'Search by name...',
    'emb.filter': 'Filter',
    'emb.all': 'All',
    'emb.no_app': 'No applications',
    'emb.personal_info': 'Personal Information',
    'emb.documents': 'Documents',
    'emb.no_doc': 'No documents',
    'emb.approve': 'Approve',
    'emb.reject': 'Reject',
    'emb.correction': 'Correction',
    'emb.notes': 'Notes',
    'emb.confirm': 'Confirm',
    'admin.title': 'Administration',
    'admin.total_users': 'Users',
    'admin.citizens': 'Citizens',
    'admin.apps': 'Applications',
    'admin.total_cards': 'Cards',
    'admin.total_emb': 'Embassies',
    'admin.by_country': 'Applications by country',
    'admin.analytics': 'Analytics',
    'analytics.title': 'Analytics Dashboard',
    'analytics.subtitle': 'Overview of statistics and trends',
    'analytics.app_trend': 'Applications Trend (12 months)',
    'analytics.user_trend': 'User Registrations (12 months)',
    'analytics.by_status': 'Applications by Status',
    'analytics.appointments': 'Appointments',
    'analytics.appts_by_embassy': 'Appointments by Embassy',
    'analytics.this_month': 'this month',
    'analytics.export_summary': 'Summary',
    'analytics.export_users': 'Users',
    'analytics.export_apps': 'Applications',
    'analytics.export_appts': 'Appointments',
    'admin.security': 'Security',
    'security.title': 'Brute-force Protection',
    'security.subtitle': 'Manage blocked IP addresses and accounts',
    'security.blocked_title': 'Blocked Entries',
    'security.no_blocked': 'No blocked addresses. System is healthy.',
    'security.failures': 'failures',
    'security.blocked_for': 'blocked for',
    'security.unblock': 'Unblock',
    'security.unblocked': 'Successfully unblocked',
    'security.rules_title': 'Progressive Blocking Rules',
    'security.rule_5': '5-minute block after 5 failed attempts',
    'security.rule_10': '30-minute block after 10 failed attempts',
    'security.rule_20': '2-hour block after 20+ failed attempts',
    'common.refresh': 'Refresh',
    'common.error': 'An error occurred',
    'admin.add_embassy': 'Add',
    'admin.edit_embassy': 'Edit embassy',
    'admin.new_embassy': 'New embassy',
    'admin.save': 'Save',
    'admin.delete': 'Delete',
    'admin.role': 'Role',
    'admin.modify': 'Edit',
    'cms.title': 'CMS Settings',
    'cms.save': 'Save',
    'cms.save_ok': 'Settings saved',
    'cms.google_title': 'Google OAuth (SSO)',
    'cms.google_desc': 'Configure sign-in with Google account',
    'cms.google_howto_title': 'How to get Google credentials:',
    'cms.google_step1': 'Go to console.cloud.google.com',
    'cms.google_step2': 'Create a project or select an existing one',
    'cms.google_step3': 'APIs & Services > Credentials > Create OAuth 2.0 Client ID',
    'cms.google_step4': 'Type: Web Application. Add the redirect URI below.',
    'cms.google_redirect_title': 'Authorized redirect URI:',
    'cms.google_redirect_help': 'Copy this URL into the "Authorized redirect URIs" in your Google console.',
    'cms.identity': 'Identity',
    'cms.identity_desc': 'Title, description and branding',
    'cms.site_title': 'Site title (browser tab)',
    'cms.site_desc': 'Site description',
    'cms.favicon': 'Favicon',
    'cms.logo': 'Logo',
    'cms.hero': 'Hero Section',
    'cms.hero_title': 'Main title',
    'cms.hero_subtitle': 'Subtitle',
    'cms.hero_image': 'Hero image',
    'cms.about_footer': 'About & Footer',
    'cms.about_text': 'About text',
    'cms.footer_text': 'Footer text',
    'cms.contact': 'Contact',
    'cms.contact_email': 'Contact email',
    'cms.contact_phone': 'Contact phone',
    'pagination.showing': 'Showing',
    'pagination.to': 'to',
    'pagination.of': 'of',
    'pagination.prev': 'Previous',
    'pagination.next': 'Next',
    'role.citizen': 'Citizen',
    'role.embassy': 'Embassy',
    'role.admin': 'Administrator',
    'common.loading': 'Loading...',
    'sections.desc': 'Add, edit and reorder landing page sections',
    'sections.add': 'Add section',
    'sections.edit': 'Edit section',
    'sections.edit_desc': 'Configure content, image and button for this section',
    'sections.empty': 'No sections yet. Click "Add" to start.',
    'sections.title': 'Title',
    'sections.subtitle': 'Subtitle',
    'sections.content': 'Content',
    'sections.image': 'Image',
    'sections.upload_image': 'Upload image',
    'sections.remove_image': 'Remove',
    'sections.image_position': 'Image position',
    'sections.pos_left': 'Left of text',
    'sections.pos_right': 'Right of text',
    'sections.button': 'Button (optional)',
    'sections.button_label': 'Button text',
    'sections.button_url': 'Button URL',
    'sections.url_suggestions': 'Internal links',
    'sections.cancel': 'Cancel',
    'sections.update': 'Update',
    'common.back': 'Back',
    'common.cancel': 'Cancel',
    'common.choose': 'Choose',
    'common.date': 'Date',
    'common.action': 'Action',
    'common.by': 'By',
    'common.no_logs': 'No logs',
    'common.country': 'Country',
    'common.city': 'City',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.address': 'Address',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.create': 'Create',
    'common.confirm_delete': 'Delete this item?',
    'appt.title': 'Appointments',
    'appt.desc': 'Book an appointment at an embassy near you',
    'appt.my_appointments': 'My appointments',
    'appt.select_embassy': 'Select embassy',
    'appt.select_embassy_desc': 'Select the embassy closest to where you live',
    'appt.select_date': 'Select date',
    'appt.select_time': 'Select time',
    'appt.no_slots': 'No available slots for this day',
    'appt.confirm_title': 'Confirm appointment',
    'appt.reason': 'Appointment reason',
    'appt.confirm': 'Confirm',
    'appt.confirmed': 'Confirmed',
    'appt.cancelled': 'Cancelled',
    'appt.no_appointments': 'No appointments',
    'appt.citizen': 'Citizen',
    'appt.time': 'Time',
    'schedule.title': 'Opening Hours',
    'schedule.desc': 'Set the opening days and hours for appointments',
    'schedule.opening_hours': 'Time Slots',
    'schedule.opening_desc': 'Configure days, hours, duration and capacity for appointments',
    'schedule.add_day': 'Add a day',
  },
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('app_lang') || 'fr');

  const switchLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('app_lang', newLang);
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.fr[key] || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
